import React, { useState, useEffect } from "react";
import { Row, Col, Label, Input, Table } from "reactstrap";
import { useSelector } from "react-redux";
import PerfectScrollbar from "react-perfect-scrollbar";
import ModalImage from "react-modal-image";
import {
  capitalizeFirstLetter,
  nullChecker,
  sumObject,
  TIPE_PETA,
  uppercaseFirstLetter,
  CHOOSE_PENGGUNAAN_TANAH,
  TIPE_PENGUASA,
  replaceToFullPath,
} from "~/utils";
import request from "~/utils/request";
import Spinner from "~/components/Spinner";

let datasCovid = [];

const ListBidangItem = ({ layer }) => {
  const datas = layer.feature.properties;

  const { desa } = useSelector((state) => state.Auth);
  const totalCovidInBidang = layer.feature.properties.jumlah_covid;

  const { bidangLayer } = useSelector((state) => state.Map);

  const [loadingData, setLoadingData] = useState(false);
  const [dataInfoBidang, setDataInfoBidang] = useState(null);

  useEffect(() => {
    datasCovid.push(layer.feature.properties);
  }, []);

  useEffect(() => {
    async function getDataInfoBidang() {
      window.scroll(0, 0); // fix scroll top after req
      setLoadingData(true);
      try {
        const response = await request.get(`/v1/sig/${datas?.id}/detailinfo`);

        setDataInfoBidang(response.data.data);
      } finally {
        setLoadingData(false);
      }
    }

    if (datas) {
      getDataInfoBidang();
    }
  }, [datas]);

  let totalCovidInDesa;

  if (datasCovid.length) {
    totalCovidInDesa = sumObject(datasCovid, "jumlah_covid");
  }

  const imageURL = datas?.gambar_depan
    ? replaceToFullPath(datas?.gambar_depan)
    : "https://via.placeholder.com/281x210";

  console.log(imageURL, "HERE");
  console.log(datas, "HERE");

  return (
    <>
      {loadingData ? (
        <Spinner className="d-block mx-auto mt-3" />
      ) : (
        <div style={{ width: "100%", overflowX: "hidden" }}>
          {bidangLayer === TIPE_PETA.COVID ? (
            <PerfectScrollbar>
              <Table striped>
                <thead>
                  <tr>
                    <th>Jumlah terpapar covid di bidang</th>
                    <th>Jumlah terpapar covid di desa</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{totalCovidInBidang}</td>
                    <td>{totalCovidInDesa}</td>
                  </tr>
                </tbody>
              </Table>
            </PerfectScrollbar>
          ) : (
            <>
              <Row>
                <Col
                  xs={12}
                  md={12}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Gambar Depan"
                >
                  <ModalImage
                    small={imageURL}
                    large={imageURL}
                    className="front-image"
                    alt="Gambar Depan"
                  />
                </Col>
              </Row>

              {datas?.properties?.desa && (
                <div className="p-2">
                  <p className="d-block text-uppercase font-weight-bold">
                    {capitalizeFirstLetter("DESA")}
                  </p>
                  <Input value={datas?.properties?.desa} readOnly />
                </div>
              )}

              {datas?.properties?.subdesa && (
                <div className="p-2">
                  <p className="d-block text-uppercase font-weight-bold">
                    {capitalizeFirstLetter(desa?.hierarki?.jenis_subdesa)}
                  </p>
                  <Input
                    value={uppercaseFirstLetter(datas?.properties?.subdesa)}
                    readOnly
                  />
                </div>
              )}

              {datas?.properties?.subsubdesa && (
                <div className="p-2">
                  <p className="d-block text-uppercase font-weight-bold">
                    {capitalizeFirstLetter(desa?.hierarki?.jenis_subsubdesa)}
                  </p>
                  <Input
                    value={uppercaseFirstLetter(datas?.properties?.subsubdesa)}
                    readOnly
                  />
                </div>
              )}

              {datas?.properties?.rw && (
                <div className="p-2">
                  <p className="d-block text-uppercase font-weight-bold">
                    {capitalizeFirstLetter("RW")}
                  </p>
                  <Input
                    value={uppercaseFirstLetter(datas?.properties?.rw)}
                    readOnly
                  />
                </div>
              )}

              {datas?.properties?.rt && (
                <div className="p-2">
                  <p className="d-block text-uppercase font-weight-bold">
                    {capitalizeFirstLetter("RT")}
                  </p>
                  <Input
                    value={uppercaseFirstLetter(datas?.properties?.rt)}
                    readOnly
                  />
                </div>
              )}

              <div className="p-2">
                <p className="d-block text-uppercase font-weight-bold">
                  Status Hak
                </p>
                <Input
                  value={nullChecker(uppercaseFirstLetter(datas.status_hak))}
                  readOnly
                />
              </div>

              <div className="p-2">
                <p className="d-block text-uppercase font-weight-bold">
                  Nomor Hak
                </p>
                <Input value={nullChecker(datas.nomor_hak)} readOnly />
              </div>

              <div className="p-2">
                <p className="d-block text-uppercase font-weight-bold">
                  Penggunaan Tanah
                </p>
                <Input
                  value={nullChecker(
                    uppercaseFirstLetter(datas.penggunaan_tanah)
                  )}
                  readOnly
                />
              </div>

              <div className="p-2">
                <p className="d-block text-uppercase font-weight-bold">
                  Pemanfaatan Tanah
                </p>
                <Input
                  value={nullChecker(
                    uppercaseFirstLetter(datas.pemanfaatan_tanah)
                  )}
                  readOnly
                />
              </div>

              <div className="p-2">
                <p className="d-block text-uppercase font-weight-bold">
                  {datas?.penggunaan_tanah ===
                  CHOOSE_PENGGUNAAN_TANAH.PERTANIAN ? (
                    <Label>Komoditas</Label>
                  ) : (
                    <Label>Keterangan</Label>
                  )}
                </p>
                <Input
                  readOnly
                  value={nullChecker(
                    uppercaseFirstLetter(datas.keterangan_pemanfaatan_tanah)
                  )}
                />
              </div>

              {/* TABEL KEPIMILIKAN BIDANG */}

              <Row className="mt-2 mb-2">
                <Col xs={12} md={12}>
                  <Label className="ml-1 text-uppercase font-weight-bold">
                    Pemilik:
                  </Label>
                </Col>
                <Col xs={12} md={12} style={{ width: 200, overflow: "auto" }}>
                  <PerfectScrollbar>
                    <Table striped>
                      <thead>
                        <tr>
                          <th>Nama</th>
                          <th>NIK</th>
                          <th>Warga</th>
                          <th>Wajib Pajak</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dataInfoBidang?.daftar_pemilik?.map((el) => (
                          <tr>
                            <td>{nullChecker(el.nama?.toUpperCase())}</td>
                            <td>{nullChecker(el.nomor_identitas)}</td>
                            <td>{el.is_warga ? "Ya" : "Bukan"}</td>
                            <td>
                              {el.is_wajib_pajak ? (
                                <i
                                  className="mdi mdi-check text-primary"
                                  style={{ fontSize: "1.4rem" }}
                                />
                              ) : (
                                <i
                                  className="mdi mdi-close text-danger"
                                  style={{ fontSize: "1.4rem" }}
                                />
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </PerfectScrollbar>
                </Col>
              </Row>

              <Row className="mt-2 mb-2">
                <Col xs={12} md={12}>
                  <Label className="ml-1 text-uppercase font-weight-bold">
                    Penguasa:
                  </Label>
                </Col>
                <Col xs={12} md={12} style={{ width: 200, overflow: "auto" }}>
                  <PerfectScrollbar>
                    <Table striped>
                      <thead>
                        <tr>
                          <th>Nama</th>
                          <th>Nomor Identitas</th>
                          <th>Tipe</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dataInfoBidang?.daftar_penguasa?.map((el) => (
                          <tr>
                            <td>{nullChecker(el.nama?.toUpperCase())}</td>
                            <td>{nullChecker(el.nomor_identitas)}</td>
                            <td>
                              {nullChecker(
                                TIPE_PENGUASA.LISTS.find(
                                  (penguasa) => penguasa.value === el.tipe
                                ).label
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </PerfectScrollbar>
                </Col>
              </Row>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default ListBidangItem;
